// extracted by mini-css-extract-plugin
export default {"blocklyBuildProgressModal":"_2joHU_5tKwpl6wbdw-kJPi"};